<template>
  <div>
    <main-header></main-header>
    <v-carousel
      width="50%"
      height="auto"
      delimiter-icon="stop"
      prev-icon="mdi-arrow-left"
      next-icon="mdi-arrow-right"
    >
      <v-carousel-item v-for="(item,i) in CarouselItems" :key="i" :src="item.src"></v-carousel-item>
    </v-carousel>
    <race-tables></race-tables>
    <application-banner></application-banner>
    <subscribe></subscribe>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainHeader from "@/components/index/MainHeader";
import RaceTables from "@/components/index/RaceTables";
import ApplicationBanner from "@/components/index/ApplicationBanner";
import Weblog from "@/components/index/Weblog";
import Subscribe from "@/components/index/Subscribe";
import MainFooter from "@/components/index/MainFooter";

export default {
  data() {
    return {
      dialog: false,
      CarouselItems: [
        {
          src: require("../../assets/1-min.jpg")
        },
        {
          src: require("../../assets/2-min.jpg")
        },
        {
          src: require("../../assets/3-min.jpg")
        },
        {
          src: require("../../assets/4-min.jpg")
        }
      ]
    };
  },
  components: {
    MainHeader,
    RaceTables,
    ApplicationBanner,
    Weblog,
    Subscribe,
    MainFooter,
  }
};
</script>

<style scoped>
</style>
